import { z } from 'zod';

// Digits only: Sameind takes the læknanúmer as an integer. Mirrors the BFF/auth check.
export const laeknanumerSchema = z.object({
  laeknanumer: z
    .string()
    .trim()
    .min(1, 'Sláðu inn læknanúmer.')
    .max(10, 'Læknanúmer má vera að hámarki 10 tölustafir.')
    .regex(/^\d+$/, 'Læknanúmer má aðeins innihalda tölustafi.'),
});

export type LaeknanumerFormValues = z.infer<typeof laeknanumerSchema>;

export interface LaeknanumerConfirmProps {
  laeknanumer: string;
  isSaving: boolean;
  onConfirm: () => void;
  onEdit: () => void;
}
